import { COIN_NAME, COIN_BALANCE_NUMBER, CLEAR_REDUX } from '../actionTypes';

const initialState = {
    coinName: "",
    coinNumberBalance: 5,
    coinInputNumberDefault: 5,
}

export const coinReducer = (state = initialState, action) => {
    switch (action.type) {
        case COIN_NAME:
            return {
                ...state,
                coinName: action.payload
            };
        case COIN_BALANCE_NUMBER:
            return {
                ...state,
                coinNumberBalance: action.payload
            };
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }
}